import { EnumPreventivoDTOStato } from '@framework/api-client/api/backoffice/schemas/enumPreventivoDTOStato.ts';
import { assertNever } from '@framework/engine/utils/assertNever.ts';
import { t } from '@framework/i18n/intl/i18next.ts';
import { StyledTag } from '@framework/ui/components/tag/StyledTag.tsx';
import { type TagProps } from 'antd';
import { type DefaultTheme, useTheme } from 'styled-components';

/**
 * Ritorna le impostazioni per il tag
 *
 */
function getTagOptions(
  state: EnumPreventivoDTOStato | undefined,
  theme?: DefaultTheme,
): TagProps {
  if (!state) return { color: '#a5c201', children: 'N/D' };
  switch (state) {
    case EnumPreventivoDTOStato.ATTESA_APPROVAZIONE:
      return {
        color: '#9E6C00',
        // color: theme?.colorPrimary ?? '#0066cc',
        children: t(
          'quote-state-tag.attesa-approvazione',
          'Attesa Approvazione',
        ),
      };
    case EnumPreventivoDTOStato.ATTESA_PAGAMENTO:
      return {
        color: theme?.colorInfo ?? '#569bc4',
        children: t('quote-state-tag.attesa-pagamento', 'Attesa Pagamento'),
      };
    case EnumPreventivoDTOStato.PAGATO:
      return {
        color: theme?.colorSuccess ?? '#389e0d',
        children: t('quote-state-tag.pagato', 'Pagato'),
      };
    case EnumPreventivoDTOStato.RIFIUTATO:
      return {
        color: theme?.colorError ?? '#fe0000',
        children: t('quote-state-tag.rifiutato', 'Rifiutato'),
      };
    // case EnumPreventivoDTOStato.SCADUTO:
    //   return {
    //     children: t('front:quote-state-tag.scaduto', 'Scaduto'),
    //   };
    // case EnumPreventivoDTOStato.REVOCATO:
    //   return {
    //     color: '#4b4f4d',
    //     children: t('front:quote-state-tag.revocato', 'Revocato'),
    //   };
    // //
  }
  assertNever(state);
}

export interface IQuoteStateTagProps {
  state?: EnumPreventivoDTOStato | null;
  mini?: boolean;
}

/**
 * Stato dei Preventivi
 */
export function QuoteStateTag(props: IQuoteStateTagProps) {
  const { state, mini } = props;
  const theme = useTheme();

  if (!state) return null;

  return <StyledTag mini={mini} {...getTagOptions(state, theme)} />;
}
